import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaArrowAltCircleLeft, FaCheck, FaEdit, FaTrash, FaThumbsUp, FaThumbsDown, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Favoris = () => {
    useAuth(); // Vérifier l'authentification

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const [qcms, setQcms] = useState([]);
    const [error, setError] = useState(null);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showInfo, setShowInfo] = useState(false);

    // Utilisation de useEffect pour mettre à jour le titre de la page et récupérer les favoris
    useEffect(() => {
        document.title = "eTrainApp | Mes favoris";

        const fetchFavoris = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-favoris/${user_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setQcms(Array.isArray(data) ? data : [data]); // Stocker les favoris récupérés
                } else {
                    setError('Votre liste de favoris est vide.');
                }
            } catch (err) {
                setError('Erreur réseau: ' + err.message);
            }
        };

        if (user_id) {
            fetchFavoris();
        }
    }, [user_id]);

    const handleDeleteFavoris = async (qcmId) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-favoris/${user_id}/${qcmId}/`, {
                method: "DELETE",
            });
            if (response.ok) {
                setQcms(qcms.filter((qcm) => qcm.id !== qcmId)); // Met à jour l'état pour supprimer le favori localement
                showAlert(' Le Qcm a été rétiré avec succès')
            } else {
                console.error("Erreur lors de la suppression du favori");
                showAlert('Erreur lors de la suppression du favori', 'danger')
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            // window.location.reload(); 
        }, 2000);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Simulation")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><BsStopwatch size={25} className='mr-2' />Simulateur
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </h2>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>Les questions misent en favoris. Cliquer sur Supprimer pour retirer une question de Mes favoris. <br /><b>Légende des icônes : </b>
                                    <i className="fa fa-thumbs-o-up ivt-align-menu"></i> indique la bonne réponse.
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}> Simulateur </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Favoris`}> Mes favoris </Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className='ibox-title'>
                                        <h2>Mes favoris ({qcms.length}) </h2>
                                    </div>
                                    <div className="ibox-content">
                                        {error ? (
                                            <p className="text-danger">{error}</p>
                                        ) : qcms.length > 0 ? (
                                            qcms.map((qcm) => (
                                                <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px' }}>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />
                                                    <div>
                                                        <span># {qcm.ref} - </span>
                                                        <span id="question" style={{ fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                    </div>
                                                    <div style={{ margin: '10px 10px' }}>
                                                        {Object.keys(qcm)
                                                            .filter(key => key.startsWith('option') && qcm[key] && (qcm[key] !== 'non défini' && qcm[key] !== 'vide'))
                                                            .map((key, index) => {
                                                                const optionLetter = String.fromCharCode(65 + index); // Convertir l'index en lettre (A, B, C, ...)
                                                                return (
                                                                    <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '12px' }}>
                                                                        <span style={{ marginRight: '2px' }}>
                                                                            {optionLetter} - {qcm[key]}
                                                                        </span>
                                                                        {qcm.reponse && Array.isArray(qcm.reponse)
                                                                            ? qcm.reponse.includes(optionLetter) && (
                                                                                <i className="fa fa-thumbs-o-up fa-2x" style={{ color: 'green', marginLeft: '5px' }}></i>
                                                                            )
                                                                            : qcm.reponse === optionLetter && (
                                                                                <i className="fa fa-thumbs-o-up fa-2x" style={{ color: 'green', marginLeft: '5px' }}></i>
                                                                            )
                                                                        }
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                    {qcm.explication && qcm.explication !== 'non défini' && (
                                                        <div style={{ color: 'green' }}>
                                                            <span>Explication : </span>
                                                            <span id="explication" style={{ fontSize: '12px', color: 'green', marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                                                        </div>
                                                    )}
                                                    <div className="d-flex justify-content-end mt-2">
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            style={{ marginLeft: 'auto' }}
                                                            onClick={() => handleDeleteFavoris(qcm.id)}
                                                        >
                                                            <FaTrash /> Retirer
                                                        </Button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p>Aucun QCM avec résultat trouvé pour cette simulation.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Favoris;
